import { createFileRoute } from '@tanstack/react-router'
import { CreateAccount } from '../components/create-account'

// "I sell gas": creates a business and its owner.
export const Route = createFileRoute('/register')({ component: () => <CreateAccount kind="business" /> })
